/* eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import map from '../static/map.png'
import {
  Header,
  HeaderParagraph,
  Product,
  Backgroundwrapper,
  Footer,
  OurClient,
  ProductDescription,
  BodyWrapper,
  MobileFooter,
  Input,
  Icon
} from '../components'
import { Element } from 'react-scroll'
import { Container, BigCircle, Font51, Font20 } from '../components/StyledComponents'
import { Helmet } from 'react-helmet'
const MobileClientLogo = styled.li``

const ButtonMLogo = styled.button`
  width: 138px;
  margin: auto;
  height: 38px;
  background: transparent;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  line-height: 1;
  color: #333333;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
  box-shadow: none;
  @media (min-width: 767px) {
    display: none;
`

const ContentWrapper = styled.div`
  max-width: 2560px;
  margin: 0 auto;
`

const SecondSection = styled.div`
  display: flex;
  padding-top: 60px;
  flex-direction: column;
  align-items: center;
  // margin-bottom: 70px;
  & + div {
    & > img {
      max-width: 100%;
    }
  }
  & ~ div {
    padding-top: 80px;
  }
  @media (max-width: 768px) {
    & ~ div {
      padding-top: 0;
    }
    // margin-bottom: 30px;
  }
  & ~ div:nth-child(odd) {
    flex-direction: row-reverse;
    @media (max-width: 840px) {
      flex-direction: column;
      align-items: center;
    }
  }
  & ~ div:last-child {
  }
`
const CoreTeamWrapper = styled.div`
  padding: 80px 0px 80px 0px;
  max-width: 1366px;
  margin: 0 auto;
  & + section {
    & > p {
      max-width: 1366px;
      word-break: break-all;
    }
    & > button {
      margin-top: 14px;
    }
  }
  @media (max-width: 768px) {
    padding: 30px 0;
    & > p {
      text-align: center;
    }
  }
`
const ProductCards = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  max-width: 1366px;
  @media (max-width: 768px) {
    & > div {
      width: 100%;
      margin: 0px auto;
    }
  }
`
const TeamMemberWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 0px;
  flex-wrap: wrap;
  max-width: 80%;
  margin: 0 auto;

  & > div {
    display: flex;
    width: 25%;
    flex-direction: column;
    & > div:first-child {
      height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      & > img {
        max-width: 190px;
      }
    }
    & > p:nth-child(2) {
      align-self: center;
      font-size: 20px;

      line-height: 1.52;
      text-align: center;
      color: #333333;
      margin: 0;
    }
    & > p:nth-child(3) {
      align-self: center;
      font-size: 16px;

      line-height: 1.63;
      letter-spacing: 0.1px;
      text-align: center;
      color: #999999;
      margin: 0;
    }
  }
  @media (max-width: 768px) {
    padding-top: 40px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    & > div {
      width: 33.33%;
      & > img {
        object-fit: cover;
      }
    }
  }
  @media (max-width: 640px) {
    padding-top: 40px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    & > div {
      width: 100%;
      & > img {
        object-fit: cover;
      }
    }
  }
`
const TeamWrapper = styled.section`
  max-width: 1366px;
  width: 100%;
  margin: 0 auto;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 40px;
    padding-bottom: 40px;
  }
  & + section {
    display: flex;
    flex-direction: column;
    align-items: center;
    & > p {
      padding-top: 10px;
    }
    & > button {
      margin-top: 30px;
    }
  }
`
const Container2 = styled.section`
  padding: ${props => (props.padding ? props.padding : '60px 80px')};
  background: ${props => (props.background ? props.background : '#fff')};
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.normal ? 'normal' : 'center')};
  margin: ${props => (props.margin ? props.margin : '0px')};
  width: 100%;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 40px 20px;
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`
const ContainerTitle = styled.h1`
  font-size: 38px;
  line-height: 1.21;
  text-align: ${props => (props.align ? props.align : 'center')};
  color: #333333;
  padding-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`
const TeamSection = styled.section`
  padding: 0px;
  & > div {
    padding-top: 80px;
    @media (max-width: 640px) {
      padding-top: 30px;
    }
    & > div > p:nth-child(3) {
      margin-bottom: 64px !important;
      @media (max-width: 640px) {
        margin-bottom: 20px !important;
      }
    }
  }
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 0;
  }
`
const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
}
  justify-content: space-between;
  @media (max-width: 992px) {
    flex-direction: column;
    width: 100%;
  }
  @media (max-width: 768px) {
    & > div {
      flex-basis: 100%;
      width: 100%;
    }
  }
`
const ContainerSubTitle = styled.p`
  font-size: 17px;
  font-weight: 300;
  line-height: 1.53;
  text-align: center;
  color: #999999;
  width: calc(100% - 0%);
  padding-left: 15%;
  padding-right: 15%;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 300;
    padding: 0;
    line-height: 1.63;
  }
  @media (max-width: 520px) {
  padding: 0;
`
const ContainerLeft = styled.div`
  flex-basis: calc(55% - 60px);
  padding-right: 60px;
  padding-left: 60px;
  @media (max-width: 992px) {
    padding: 20px;
    flex-basis: calc(100% - 0px);
  }
  & > p {
    font-size: 16px;
    line-height: 1.6;
    letter-spacing: 0.8px;
    color: #333333;
    padding-bottom: 4px;
    font-weight: 500;
  }
  & > p:nth-child(2) {
    font-size: 38px;
    font-weight: 400;
    line-height: 1.2;
    padding-bottom: 10px;
    letter-spacing: 2.4px;
    font-weight: 400;
    color: #333333;
    margin: 0;
  }
  & > p:nth-child(3) {
    // width: 448px;
    font-weight: 400;
    margin-bottom: 20px;
    color: #666666;
  }
  @media (max-width: 768px) {
    & > p {
      font-size: 14px;
    }
    & > p:nth-child(2) {
      font-size: 24px;
    }
  }
`
const ContainerRight = styled.div`
  flex-basis: 45%;
  & > div:first-child {
    display: none;
    @media (max-width: 768px) {
      display: block;
    }
  }
  & > div:last-child {
    display: block;
    @media (max-width: 768px) {
      padding-top: 0px;
    }
  }
`
const TopWrapper = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 40px 16px 20px;
    & > h1 {
      font-size: 28px !important;
      line-height: normal !important;
      letter-spacing: normal !important;
    }
    & > p {
      font-size: 16px !important;
      font-weight: 300 !important;
      line-height: 1.38 !important;
      letter-spacing: 0.1px !important;
    }
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 80px 250px 60px 80px;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  & > p {
    text-align: left;
    padding: 0;
    padding-top: 10px;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.61;
  }
  & > h1 {
    font-size: 48px;
    line-height: 1.27;
    color: #333333;
  }
`
const ImageWrapper = styled.div`
  & > img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
  @media (max-width: 768px) {
    & > img {
      height: 200px;
    }
  }
`
const FormWrapper = styled.form`
  display: flex;
  padding-top:20px;
  @media (max-width: 520px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    & > div > input {
      width: 100%;
      margin-bottom: 10px;
    }
    & > button {
      width: 100%;
      border-radius 4px;
    }
  }
`
const ButtonComponent = styled.button`
  width: ${props => (props.width ? props.width : 186)}px;
  height: ${props => (props.height ? props.height : 48)}px;
  background: ${props => (props.background ? props.background : '#333333')};
  border-radius: ${props => (props.radius ? props.radius : '4px')};
  border: ${props => (props.border ? props.border : 'none')};
  line-height: 1;
  letter-spacing: 1px;
  color: ${props => (props.color ? props.color : '#fff')};
  cursor: pointer;
  text-transform: ${props => (props.transform ? props.transform : 'uppercase')};
  font-family: Montserrat;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 1px;
  box-shadow: ${props => (props.shadow ? props.shadow : 'none')};
  -webkit-tap-highlight-color: transparent;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
  }
  &:focus {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
    outline: none;
  }
  @media (max-width: 768px) {
    height: 38px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1.1px;
  }
`
const FromGroup = styled.div`
  width: 100%;
  margin-right: 20px;
  margin: 8px;
  input,
  textarea {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    width: 100%;
  }
  input {
  }
  textarea {
    padding: 10px;
    min-height: 150px;
    :focus {
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
      outline: none;
    }
  }
`
const ContactFrom = styled.div`
  margin-top: 50px;
`
const AddressWrap = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  margin-top: 20px;
  margin-left: 30px;

  @media (max-width: 768px) {
    margin-left: 0px;
  }
`
const AddressContent = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 0;
  a {
    color: #000;
  }
  > span {
    margin-right: 10px;
  }
  p {
    font-size: 14px;
    color: #555;
    font-weight: 500;
    margin-bottom: 5px;
  }
  p span {
    font-weight: bold;
    display: block;
    font-size: 16px;
    color: #000;
  }
`
export const Button = props => {
  return (
    <ButtonComponent
      color={props.color}
      height={props.height}
      width={props.width}
      background={props.background}
      border={props.border}
      radius={props.radius}
      {...props}>
      {props.title}
    </ButtonComponent>
  )
}

class AppDevelopment extends Component {
  state = {
    collapse: false,
    MobileLogo: true,
    MobileLogoText: 'View More',
    selected: 'V'
  }
  MobileLogoButton = e => {
    this.setState({ MobileLogoText: this.state.MobileLogo ? 'Less' : 'View More' })
    this.setState({ MobileLogo: !e })
  }

  render() {
    const { selected } = this.state
    console.log(selected)
    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Mobile App Development In India | Android & iOS App Development | 8om</title>
          <meta
            name="description"
            content="Mobile App development services that help businesses turn their ideas into real apps with innovative & customised solutions and top of the class app developers."
          />
          <meta
            name="keywords"
            content="mobile app development, App Developer, android app development, ios app development, iphone app development"
          />
        </Helmet>
        <Header />
        <ContentWrapper>
          <TopWrapper>
            <HeaderParagraph
              headerColor={'#333333'}
              headerFontSize={'38px'}
              header={'App Development'}
              paragraph={
                '8om helps businesses turn their ideas into real apps. Our customised solutions for each client help drive innovation.'
              }
            />
          </TopWrapper>
          <ImageWrapper>
            <img src={require('../static/appdevelopment.jpg')} alt="Services" />
          </ImageWrapper>
          <Container padding="20px">
            <SecondSection>
              <HeaderParagraph
                headerColor={'#333333'}
                header={'Services'}
                alignCenter
                paragraph={
                  'The best tools and hand-picked tech talent, allows us to accelerate your business and create intense future mobile experiences.'
                }
                headerFontSize={'48px'}
              />
            </SecondSection>
            <Product
              contentPadding="32px 20PX 0 70px"
              img={require('../static/Android.png')}
              productName={'Android App'}
              featureOne={'Scalable apps for all kinds of android devices.'}
              featureTwo={'Apps for the latest Android OS versions in the market.'}
              featureThree={'Customer-centric apps designed for all display sizes.'}
              featureFour={'Apps aiding you expand rapidly via affordable devices.'}
              redirectTo={'https://extract.8om.io'}
              titleName={''}
              flexBasis={'inherit'}
              imgSize
            />

            <Product
              contentPadding="32px 20px 0 70px"
              img={require('../static/ios.png')}
              productName={'iOS App'}
              featureOne={'Apps that add to the elegance of iOS devices.'}
              featureTwo={'Scalable apps for the entire iOS platform.'}
              featureThree={'Enterprise-grade apps with futuristic features.'}
              featureFour={'Ultimate UI/UX to engage your niche audience.'}
              redirectTo={'https://trckr.8om.io'}
              titleName={''}
              flexBasis={'inherit'}
              imgSize
            />

            <Product
              contentPadding="32px 20PX 0 70px"
              img={require('../static/HybridNative.png')}
              productName={'Hybrid Native Apps'}
              featureOne={'Apps with extensible code for futuristic features'}
              featureTwo={'Consistent design even with less time and efforts.'}
              featureThree={'Cost-efficient approach to providing your services.'}
              featureFour={'Apps for wider audience with less grind for marketing.'}
              redirectTo={'/books'}
              titleName={''}
              flexBasis={'inherit'}
              imgSize
            />
          </Container>
          <Container background="#fafbfc">
            <CoreTeamWrapper>
              <HeaderParagraph
                alignCenter
                headerColor={'#333333'}
                headerFontSize={'38px'}
                header={'Platforms'}
                paragraph={
                  'Our dedicated team uses trusted yet latest technology platforms so that your business loses no opportunity to grow.'
                }
              />
              <TeamMemberWrapper>
                <div>
                  <div>
                    <img src={require('../static/ReactNative3.png')} alt="Mentor Business" />
                  </div>
                  <p>React Native</p>
                </div>
                <div>
                  <div>
                    <img src={require('../static/NativeScript.png')} alt="Mentor Marketing" />
                  </div>
                  <p>Native Script</p>
                </div>
                <div>
                  <div>
                    <img src={require('../static/Flutter.png')} alt="CEO" />
                  </div>
                  <p>Flutter</p>
                </div>
                <div>
                  <div>
                    <img src={require('../static/Firebase.png')} alt="Mentor Business" />
                  </div>
                  <p>Firebase</p>
                </div>
              </TeamMemberWrapper>
            </CoreTeamWrapper>
          </Container>

          <TeamWrapper>
            <TeamSection>
              <HeaderParagraph headerColor={'#333333'} alignCenter headerFontSize={'38px'} />

              <FlexContainer>
                <ContainerLeft>
                  <p> </p>
                  <p align="left">Technologies</p>
                  <p>
                    Our experienced and versatile tech nerds show off their skills using the best technologies available
                    in the market.
                  </p>
                </ContainerLeft>
                <ContainerRight>
                  {/* <OurTeamMobileView /> */}
                  <BigCircle>
                    <img src={require('../static/Technologies2.png')} alt="Team" />
                  </BigCircle>
                </ContainerRight>
              </FlexContainer>
            </TeamSection>
          </TeamWrapper>

          <Element name="features">
            <Container padding={' 0px 80px 50px 80px'} background="transparent">
              <Font51>Industries</Font51>
              <Font20>We have proven experience across a number of market sectors like</Font20>
              <ProductCards>
                <ProductDescription
                  icon={'Industries2/retail.png'}
                  title="Retail"
                  width="20"
                  description="From warehouse operations to stock orders, our apps provide simplified
                solutions to every retail business need."
                />
                <ProductDescription
                  icon={'Industries2/eCommerce.png'}
                  title="eCommerce"
                  width="20"
                  description="An engaging experience to your valuable customers and high revenue to
                your brand, is what our apps provide."
                />
                <ProductDescription
                  icon={'Industries2/Blockchain.png'}
                  title="Blockchain"
                  width="20"
                  description="Be it an ICO launch or Smart Contracts, we create the required secure
                decentralised ecosystem for your brand."
                />
                <ProductDescription
                  icon={'Industries2/Manufacturing.png'}
                  title="Manufacturing"
                  width="20"
                  description="From production to revenue, our skilled tech nerds have it all figured with the
                bespoke apps they create for you."
                />
                <ProductDescription
                  icon={'Industries2/Health&Sustainability.png'}
                  title="Health & Sustainability"
                  width="20"
                  description="From patients to those who give care, our simple, scalable and sustainable
                apps are created empathically for all."
                />
              </ProductCards>
            </Container>
          </Element>
          <TopWrapper>
            <HeaderParagraph
              headerColor={'#333333'}
              headerFontSize={'38px'}
              header={'Get In Touch'}
              paragraph={'Sent us a message'}
            />

            <FlexContainer>
              <ContactFrom>
                <form action="https://formspree.io/harsh@8om.io" method="POST">
                  <FlexContainer>
                    <FromGroup>
                      <Input type="name" icon="user" name="Name" placeholder="Name" changeColor={'#35cc62'} required />
                    </FromGroup>
                    <FromGroup>
                      <Input
                        type="email"
                        name="_replyto"
                        icon="email"
                        placeholder="Email"
                        changeColor={'#35cc62'}
                        onChange={this.handleChange}
                        value={this.state.email}
                        required
                      />
                    </FromGroup>
                  </FlexContainer>
                  <FlexContainer>
                    <FromGroup>
                      <Input
                        type="phone"
                        name="contact"
                        icon="contact"
                        placeholder="Phone"
                        changeColor={'#35cc62'}
                        required
                      />
                    </FromGroup>
                  </FlexContainer>
                  <FlexContainer>
                    <FromGroup>
                      <textarea name="textarea" id="" placeholder="Your message type here" />
                    </FromGroup>
                  </FlexContainer>
                  <input type="hidden" name="_next" value="/" />
                  <FromGroup>
                    <Button type="submit" title="Submit" />
                  </FromGroup>
                </form>
              </ContactFrom>

              <AddressWrap>
                <AddressContent>
                  <span>
                    <Icon icon="contact" />
                  </span>
                  <p>
                    Phone
                    <span>
                      <a href="tel:+918076157787"> +91 8076157787</a>
                    </span>
                  </p>
                </AddressContent>
                <AddressContent>
                  <span>
                    <Icon icon="email" />
                  </span>
                  <p>
                    Email
                    <span>
                      <a href="mailto:harsh@8om.io"> harsh@8om.io</a>
                    </span>
                  </p>
                </AddressContent>
                <AddressContent>
                  <span>
                    <Icon icon="website" />
                  </span>
                  <p>
                    Website
                    <span>8om.io</span>
                  </p>
                </AddressContent>
                {/*  <AddressContent>
                  <span>
                    <Icon icon="location" />
                  </span>
                  <p>
                    Location
                    <span>
                      3rd Floor, Plot No. 8 Balaji Estate,
                      <br /> Guru Ravidas Marg, Kalkaji,
                      <br /> New Delhi, Delhi 110019
                    </span>
                  </p>
                </AddressContent> */}
              </AddressWrap>
            </FlexContainer>
          </TopWrapper>

          <Container2 normal background={'#fafbfc'} padding={'80px 0 80px 0'}>
            <ContainerTitle>Our Clients Around The World</ContainerTitle>
            <ContainerSubTitle>
              Our clients are valuable to us and we’re always inspired by them and their need to make their business
              better.
            </ContainerSubTitle>
            <Backgroundwrapper>
              <OurClient>
                <ul>
                  <li>
                    <img src={require('../static/client_logo/m-tech.jpg')} alt="M-tech" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/munafamart.png')} alt="Munafamart" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/creatanium.png')} alt="Cretanium" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/beccos.jpg')} alt="Beccos" />
                  </li>
                  <li>
                    <img src={require('../static/client_logo/greenchoice.png')} alt="Greenchoice" />
                  </li>
                </ul>
              </OurClient>
            </Backgroundwrapper>
          </Container2>
        </ContentWrapper>
        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </Fragment>
    )
  }
}

export default withRouter(AppDevelopment)



// WEBPACK FOOTER //
// ./src/pages/AppDevelopment.js